
<template>
	<section class="margin-15">
		<template v-if="isEdit">
			<vFormItem label-width="auto" inline label="ERP SKU:">
				<!-- <vInput v-model="formData.sku"></vInput> -->
				<vSelect v-model="formData.sku">
					<vOption v-for="item in data" :key="item.id" :value="item.sku">{{item.sku}}</vOption>
				</vSelect>
			</vFormItem>
			<vFormItem label-width="auto" inline :label="$t('global.common.quantity',{defaultValue:'数量'})">
				<vInputNumber clearable v-model="formData.qty" :min="1" math="round" />
			</vFormItem>
            <vFormItem label-width="auto" inline label="库存类型:">
				<!-- <vSelect v-model="formData.inventoryType">
					<vOption v-for="item in getInventoryType" :key="item.value" :value="item.value">{{item.label}}</vOption>
				</vSelect> -->
                不可售库存
			</vFormItem>
			<vButtonGroup class="inline padding-left-10">
				<vButton
					theme="primary"
					@click="addItem(formData)"
				>{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
			</vButtonGroup>
			<vButtonGroup>
				<vButton theme="warning" @click="removeItems">{{$t('global.common.delete',{defaultValue:'删除'})}}</vButton>
				<vButton theme="error" @click="clearAll">{{$tc('global.common.clear',1,{defaultValue:'清空所有'})}}</vButton>
			</vButtonGroup>
		</template>
		<vTableSimple
			style="max-height:200px;overflow:auto"
			class="margin-top-10"
			:columns="columns"
			:data="dataList"
			@on-check-change="handleCheckData"
		></vTableSimple>
        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
            <img v-if="modalProps.url" style="width: 800px; height: auto;" :src="modalProps.url" />
		</compModal>
	</section>
</template>
<script>
import mixin from "../mixin";
export default {
	mixins: [mixin],
	props: ['data', 'isEdit', 'activeType'],
	components: {
	},
	data() {
		return {
			loading: false,
			type: this.$route.params.type || this.activeType,
			id: this.$route.query.id,
			formData: {
				inventoryType: 1
			},
			dataList: [],
			checkedData: [],
            modalProps: {
				show: false,
			},
		}
	},
	watch: {
		data: {
			immediate: true,
			handler(val) {
				this.dataList = (val || []).filter(item => !!item.id);
			}
		}
	},
	computed: {
		columns() {
			return [{
				type: 'selection',
				formName: 'sku',
				width: this.type === 'query' ? 0 : 60
			},
            {
				title: "No.",
				type: 'index',
                width:60
			},
            {
				title: "SKU",
				key: 'sku',
                width:150
			},
            {
                title: '建议处理方式',
                key: 'goodsReturnType',
                width:150
            },
            {
				title: this.$t('', { defaultValue: '收货数量' }),
				key: 'qty',
			},
            {
				title: this.$t('fbb.common.inventoryType', { defaultValue: '库存类型' }),
				key: 'inventoryType',
				render: (h, { row }) => this.findRenderLabel(this.getInventoryType, row.inventoryType),
			},
            {
                title: '照片',
                key: 'picturesUrl',
                render: (h, {row})=>{
                    let img = [];
                    if(row.picturesUrl){
                        row.picturesUrl.map(item => {
                            img.push(
                                <div style="float: left; cursor: pointer; margin-right: 10px;" onClick={this.handleImgModal.bind(this, item)}>
                                    <img style="width: 50px; height: 50px;" src={item} />
                                </div>
                            )
                        });
                    }
                    return (
                        <div style="padding: 10px 0; overflow: hidden;">
                            {img}
                        </div>
                    );
                },
				width: this.type === 'edit' ? 0 : null
            },
            {
                title: '照片备注',
                key: 'processRemark',
                render: (h, {row})=>{
                    return row.processRemark||'--'
                },
				width: this.type === 'edit' ? 0 : null
            },
            {
				title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
				key: 'updatedAt',
			}]
		}
	},

	methods: {
        handleImgModal (url) {
            this.modalProps = {
                show: true,
                title: this.$t('global.photo.info', { defaultValue: '照片信息' }),
                showFooter: false,
                width: 836,
                zIndex: 9999,
                url: url,
            }
        },
		handleCheckData(rows, val) {
			this.checkedData = val;
		},
		addItem(data) {
			const { sku, qty, inventoryType } = data;
			if (sku && qty) {
				const erpSkuData = this.dataList.find((item) => item.sku === sku && inventoryType == item.inventoryType);
				if (erpSkuData) {
					erpSkuData.qty += qty;
				} else {
					const dataItem = { ...this.data.find((item) => item.sku === sku) || {} };
					delete dataItem.id;
					this.dataList.push({ ...dataItem, ...data });
				}
				this.formData = { qty: '', sku: '', inventoryType: 1 };
				return;
			}
			this.$VMessage.warning(this.$t('fbb.salesreturns.fill_erpskuno', { defaultValue: '请填写ERPSKU和数量' }));
		},
		clearAll() {
			this.dataList = [];
		},
		removeItems() {
			const checkedData = this.checkedData;
			if (!checkedData.length) return;
			this.dataList = this.dataList.filter((item) => {
				return checkedData.indexOf(item.sku) == -1
			})
		},
	}
}
</script>
